import React from 'react';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import { formatNumber, genericFormatAmount } from '@panel/commons/helpers/formatAmount';

const PriceCard = ({ priceData }) => {
  const { t } = useTranslation();
  const { currency, differenceAverage, m2PostingAmount, max, min, range } = priceData;
  const sectionIds = [1, 2, 3, 4, 5];

  const getRangeStatus = () => {
    if (range < 3) return 'bajo';
    if (range > 3) return 'alto';
    return 'coincide';
  };

  return (
    <ComponentLayout>
      <PriceHeader>{t('panel.desempeno.tips.adicional.titulo.posting_price')}</PriceHeader>
      <PriceDescription>
        {t(`panel.desempeno.tips.adicional.${getRangeStatus()}.posting_price`, {
          percent: `${formatNumber(differenceAverage)}%`
        })}
      </PriceDescription>
      <PriceGraph>
        <GraphLabel>{genericFormatAmount(min, currency)}</GraphLabel>
        <GraphLabel isRight>{genericFormatAmount(max, currency)}</GraphLabel>
        {sectionIds.map(id => (
          <GraphSection key={id} isActive={range === id} rangeStatus={getRangeStatus()}>
            <GraphMarker isActive={range === id} id={id}>
              {genericFormatAmount(m2PostingAmount, currency)}
            </GraphMarker>
          </GraphSection>
        ))}
      </PriceGraph>
    </ComponentLayout>
  );
};

const sectionColors = {
  bajo: select('positive'),
  coincide: select('yellow'),
  alto: select('negative'),
  not_apply: select('middleGray')
};

const ComponentLayout = styled.div`
  border: 1px solid ${select('middleGray')};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 15px;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;

const PriceHeader = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
`;

const PriceDescription = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: ${select('darkGray')};
  white-space: pre-wrap;
  margin-top: 10px;
`;

const PriceGraph = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-top: 28px;
  margin-bottom: 15px;
  > div:last-child {
    margin-right: 0px;
  }
`;

const GraphSection = styled.div`
  position: relative;
  height: 5px;
  flex: 1;
  margin-right: 5px;
  background-color: ${({ rangeStatus, isActive }) => (isActive ? sectionColors[rangeStatus] : sectionColors.not_apply)};
`;

const GraphMarker = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  position: absolute;
  bottom: 7px;
  text-align: center;
  width: 100%;
  display: ${({ isActive }) => (isActive ? 'inline-block' : 'none')};
`;

const GraphLabel = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  position: absolute;
  top: 7px;
  ${({ isRight }) =>
    isRight
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
`;

export default PriceCard;
